import { useMemo } from 'react'

import {
  type FilterListShort,
  useListListsQuery,
} from '@/legacy-api/filter-lists-slice.gen'

export type FilterListsMap = Record<string, FilterListShort>

export function useGetFilterListsMap() {
  const { data, isLoading, error } = useListListsQuery()

  const filterListsMap = useMemo<FilterListsMap>(() => {
    if (!data?.data) return {}

    return data.data.reduce<FilterListsMap>((acc, list) => {
      acc[list.list_id] = list
      return acc
    }, {})
  }, [data?.data])

  return { filterListsMap, isLoading, error }
}
